export default __webpack_public_path__ + "static/media/kitchen-4.48e3f16d.jpg";